<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <div>
      <div class="mt-4">
        <h5><i class="dot"></i> 수행평가 대상</h5>
      </div>
      <div class="writeGridContainer mt-4" style="align-items: center">
        <div>
          <div>부서(업체)명</div>
          <span v-if="isPrint" class="print-input"> {{ form.companyName }} </span>
          <CompanySelector v-else :readonly="board.readonly" class="w-full flex-1" :fieldId="form.stdInfo.field_id" v-model="form.inputA_1" placeholder="선택" @select="targetCompany"></CompanySelector>
        </div>
        <div>
          <div>피평가자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
          <ml-input v-else v-model="form.inputA_2" />
        </div>
        <div>
          <div>평가일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_3 }}</p>
          <date-selector v-else v-model="form.inputA_3" />
        </div>
      </div>

      <div class="mt-4 mb-2">
        <h5><i class="dot"></i> 구분</h5>
      </div>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <template v-if="isPrint">
            <div class="item-box-check" v-if="form.checked === '상반기'" style="text-align: center;  align-self: center;">
              <vs-icon icon="check" size="small"  ></vs-icon>
            </div>
            <div v-else class="item-box-check">
            </div>
            상반기
          </template>
          <vs-checkbox
            v-else
            class="item-box-check"
            :checked="form.checked === '상반기'"
            @change="checkForm($event, '상반기')"
          >상반기</vs-checkbox>
        </div>

        <div class="col-span-4 flex items-center">
          <template v-if="isPrint">
            <div class="item-box-check" v-if="form.checked === '하반기'" style="text-align: center;  align-self: center;">
              <vs-icon icon="check" size="small"  ></vs-icon>
            </div>
            <div v-else class="item-box-check">
            </div>
            하반기
          </template>
          <vs-checkbox
            v-else
            class="item-box-check"
            :checked="form.checked === '하반기'"
            @change="checkForm($event, '하반기')"
          >하반기</vs-checkbox>
        </div>
      </div>
    </div>

    <table-inspect-evaluate
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      title="업무 수행 여부"
      :list="form.inspectList"
      :is-note="false"
      :is-not-dot-in-label="true"
      :sum-allot="form.inspectAllot"
      :sum-point="form.inspectPoint"
      @update-point="updatePoint"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-8"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import TableInspectEvaluate from "@/components/TableInspectEvaluate.vue";

export default {
  components: {
    TableInspectEvaluate,
    CompanySelector,
    DateSelector,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }

        this.sumAllot()

      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
    'form.inspectList': {
      immediate: true,
      deep: true,
      handler(value) {

        let sum = 0
        value.forEach((item) => {
          sum += Number(`${item.point}`)
        })

        this.form.inspectPoint = sum
      }
    }
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        companyName: "",
        checked: "",
        inspectList: [],
        inspectAllot: 0,
        inspectPoint: 0,

        inputA_1: '',
        inputA_2: '',
        inputA_3: '',
      },
    };
  },
  methods: {
    targetCompany(value) {
      this.form.companyName = value.com_name;
    },
    checkForm (value, text) {
      this.form.checked = text
    },
    updatePoint (indexRows, allow, point) {
      this.form.inspectList[indexRows].point = Number(`${point}`)
    },
    sumAllot() {
      let sum = 0
      this.form.inspectList.forEach((item) => {
        sum += item.allot
      })
      this.form.inspectAllot = sum
    },
  },
  computed: {
    inspectTable() {
      return [
        {
          id: 1,
          label: '· 학교(기관) 관리감독자 법정 교육 이수 여부\n※ 법정 교육: 미이수 시 5점 감점',
          allot: 10,
          title: '1. 안전보건관리 조직 운영',
          titleColor: "#f9f9f9",
        },
        {
          id: 2,
          label: '· 안전·보건관리자, 산업보건의 등 지도·조언에 대한 협조\n※ 미협조 시 1건당 1점씩 감점',
          allot: 10,
          title: '1. 안전보건관리 조직 운영',
        },
        {
          id: 3,
          label: '· 현업종사자 대상별 법정 교육 시행 유무\n· 신규채용 시 교육\n· 정기안전보건교육\n· 물질안전보건자료(MSDS) 교육\n※ 교육 미실시 근로자 1명당 1점씩 감점',
          allot: 20,
          title: '2. 교육 및 위험성 평가',
          titleColor: "#f9f9f9",
        },
        {
          id: 4,
          label: '· 위험성평가 유해·위험요인 파악 및 개선조치\n· 개선실행계획서 조치 이행 여부\n※ 개선조치 미실시 1건당 1점씩 감점',
          allot: 20,
          title: '2. 교육 및 위험성 평가',
        },
        {
          id: 5,
          label: '· 산업재해(업무상 사고) 발생 및 산업재해조사표 1개월 이내 제출 적정 여부\n※ 산업재해조사표 제출 1건당 2점씩 감점\n(출퇴근 재해 및 질병은 제외)\n※ 산업재해조사표 지연(1개월 초과) 제출 시, 1건당 5점씩 감점',
          allot: 20,
          title: '3. 보건관리',
          titleColor: "#f9f9f9",
        },
        {
          id: 6,
          label: '1. 기계,기구 또는 설비의 안전·보건 점검 및 이상 유무의 확인',
          allot: 5,
          title: '4. 위험·건강장해 방지',
          titleColor: "#f9f9f9",
          subTitle: '· 안전·보건 관계 법령 의무 이행 여부\n※ 미이행 시 1건당 1점씩 감점'
        },
        {
          id: 7,
          label: '2. 작업복·보호구 및 방호장치의 점검과 그 착용· 사용에 관한 교육지도',
          allot: 5,
          title: '4. 위험·건강장해 방지',
          titleColor: "#f9f9f9",
        },
        {
          id: 8,
          label: '3. 작업장 정리·정돈 및 통로 확보에 대한 확인· 감독',
          allot: 5,
          title: '4. 위험·건강장해 방지',
          titleColor: "#f9f9f9",
        },
        {
          id: 9,
          label: '4. 작업장 유해 또는 위험한 기계·기구 및 설비에 대한 자체점검',
          allot: 5,
          title: '4. 위험·건강장해 방지',
          titleColor: "#f9f9f9",
        },
      ]
    },
  }
};
</script>

<style scoped lang="scss">
</style>
